module.exports = __webpack_public_path__ + "img/electrical_engineer_stats.2ea43ce4.png";